import { render, staticRenderFns } from "./_orders.vue?vue&type=template&id=3d9d21e2&"
import script from "./_orders.vue?vue&type=script&lang=ts&"
export * from "./_orders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9d21e2')) {
      api.createRecord('3d9d21e2', component.options)
    } else {
      api.reload('3d9d21e2', component.options)
    }
    module.hot.accept("./_orders.vue?vue&type=template&id=3d9d21e2&", function () {
      api.rerender('3d9d21e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/_orders.vue"
export default component.exports